<!-- <nav aria-label="Page navigation example" ngClass="{{ data.customClass }}" class="adc-p25" *ngIf="type == 'basic'">
    <ul class="adc-pagination">
      <li><a>&laquo;</a></li>
      <li><a>1</a></li>
      <li><a>2</a></li>
      <li><a>3</a></li>
      <li><a>&raquo;</a></li>
    </ul>
</nav> -->
<!-- 
<nav aria-label="Page navigation example" ngClass="{{ data.customClass }}" class="adc-p25" *ngIf="type == 'action'">
    <ul class="adc-pagination">
      <li><a>&laquo;</a></li>
      <li><a>1</a></li>
      <li><a class="adc-page-link adc-active">2</a></li>
      <li><a>3</a></li>
      <li><a>&raquo;</a></li>
    </ul>
  </nav>

  <nav aria-label="Page navigation example" ngClass="{{ data.customClass }}" class="adc-p25" *ngIf="type == 'disabled'">
    <ul class="adc-pagination">
      <li><a>&laquo;</a></li>
      <li class="adc-page-item disabled"><a>1</a></li>
      <li><a>2</a></li>
      <li><a>3</a></li>
      <li><a>&raquo;</a></li>
    </ul>
  </nav>

  <nav aria-label="Page navigation example" ngClass="{{ data.customClass }}" class="adc-p25" *ngIf="type == 'RoundedBorder'">
    <ul class="adc-pagination adc-pagination-rounded">
      <li><a>&laquo;</a></li>
      <li><a>1</a></li>
      <li><a>2</a></li>
      <li><a>3</a></li>
      <li><a>&raquo;</a></li>
    </ul>
 </nav> -->

 <div class="pagination-card">
  <div class="pagination">
      <span><p class="adc-m0">Go to page:</p></span>
      <input type="number" min="1" [max]="calculateTotalPages()" [(ngModel)]="currentPage" (change)="goToPage(currentPage)">
      <span><p class="adc-m0">/ {{ calculateTotalPages() }} pages</p></span>
      <span class="adc-fs-2">|</span>
      <span><p class="adc-m0">Items per page:</p></span>
      <div class="adc-dropdown">
        <input type="text" [value]="itemsPerPage" readonly (click)="openItemsPerPage()">
        <div class="adc-dropdown-option-menu menu-width items" *ngIf="itemsPerPageOpen">
            <a class="adc-dropdown-options" *ngFor="let data of itemsPerPageArr" (click)="itemsPerPageVal(data)">{{data}}</a>
        </div>
      </div>
      <span class="adc-fs-2">|</span>
      <div class="adc-d-flex adc-gap-2">
        <span class="italic">Showing:</span>
        <span><p class="adc-m0">{{ getStartIndex() }}</p></span> - 
        <span><p class="adc-m0">{{ getEndIndex() }}</p></span>
        <span>of</span>
        <span><p class="adc-m0">{{ totalItems }} items</p></span>
      </div>
      <span class="material-symbols-outlined" title="First Page" (click)="firstPage()">keyboard_double_arrow_left</span>
      <span class="material-symbols-outlined" title="Previous Page" (click)="previousPage()">keyboard_arrow_left</span>
      <span class="material-symbols-outlined" title="Next Page" (click)="nextPage()">keyboard_arrow_right</span>
      <span class="material-symbols-outlined" title="Last Page" (click)="lastPage()">keyboard_double_arrow_right</span>
  </div>
</div>